module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"translatedFrom":{"fr":"Translated from French by DeepL"}},"fr":{"translatedFrom":{"en":"Traduit de l\u0027anglais par DeepL"}}}')
  delete Component.options._Ctor
}
